import {FormField, Input, InputField, SelectGeneric} from "@hosttools/frontend";
import type React from "react";
import {memo, useCallback} from "react";
import {Controller, useForm} from "react-hook-form";

import RowAction from "../RowAction";
import type {ListingAttributesWithQuantity} from "../type";

import type {OptionType} from "@/client/components/Select";
import {TableCell, TableRow} from "@/client/components/Table";

type Props = {
    item?: ListingAttributesWithQuantity;
    attributeOptions: OptionType<ListingAttributesWithQuantity["attributeId"]>[];
    index?: number;
    onChange: (item: ListingAttributesWithQuantity, index?: number) => void;
    onCancel: () => void;
};

const Form: React.FC<Props> = ({item, index, attributeOptions, onChange, onCancel}) => {
    const {
        control,
        register,
        handleSubmit,
        formState: {errors}
    } = useForm<ListingAttributesWithQuantity>({
        defaultValues: item ?? {
            attributeId: "",
            quantity: undefined
        }
    });

    const handleSave = useCallback(
        (item: ListingAttributesWithQuantity) => {
            onChange(item, index);
        },
        [index, onChange]
    );

    return (
        <TableRow>
            <TableCell>
                <FormField error={errors?.attributeId?.message}>
                    <Controller
                        control={control}
                        name="attributeId"
                        render={({field}) => {
                            return (
                                <SelectGeneric
                                    options={attributeOptions}
                                    placeholder="Select..."
                                    value={field.value}
                                    onChange={field.onChange}
                                />
                            );
                        }}
                        rules={{required: "Please select attribute."}}
                    />
                </FormField>
            </TableCell>
            <TableCell>
                <FormField error={errors?.quantity?.message}>
                    <Input isRequired>
                        <InputField
                            id="quantity"
                            placeholder="Quantity...."
                            testID="quantity"
                            type="number"
                            {...register("quantity", {
                                required: "Please enter quantity.",
                                min: {
                                    value: 1,
                                    message: "This must be greater than 0"
                                }
                            })}
                        />
                    </Input>
                </FormField>
            </TableCell>
            <TableCell align="end">
                <RowAction onCancel={onCancel} onSubmit={handleSubmit(handleSave)} />
            </TableCell>
        </TableRow>
    );
};

export default memo(Form);
